import { render, staticRenderFns } from "./e-status-chip.vue?vue&type=template&id=2397f684&scoped=true&lang=pug"
import script from "./e-status-chip.vue?vue&type=script&lang=js"
export * from "./e-status-chip.vue?vue&type=script&lang=js"
import style0 from "./e-status-chip.vue?vue&type=style&index=0&id=2397f684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397f684",
  null
  
)

export default component.exports